var Handlebars = require("/home/jenkins/agent/workspace/hybrid-accsts-task-release/hybrid-accsts-jsclient/target/toolchain/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"header\"></div>\n<div class=\"top-pane\"></div>\n<div class=\"slider-wrapper horizontal\">\n    <div class=\"slider-base\">\n        <div class=\"slider-handle\">\n        </div>\n    </div>\n</div>\n<div class=\"bottom-pane\"></div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./app/lib/common/resizable/templates/vertical_layout.hbs
// module id = 1431
// module chunks = 0